import React from 'react'

export const BurgerNav = (props) => {
    return (
        <div style={{ ...props.style, width:'48px', padding:'3px'}}>
        <svg
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill={props.color || '#000'}
                stroke={props.stroke || '#000'}
                strokeWidth={props.strokeWidth || 0.1}
                d="M 2 5 L 2 7 L 22 7 L 22 5 L 2 5 z M 2 11 L 2 13 L 22 13 L 22 11 L 2 11 z M 2 17 L 2 19 L 22 19 L 22 17 L 2 17 z" />
        </svg>
    </div>
    )
}
